import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function usePreExistingTemplateApi() {
    const callApi = useApiCall()
    const getTemplate = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.PREEXISTING_TEMPLATE.GET_TEMPLATE, data, onSuccess, onError)
    }
    return {
        getTemplate,
    }
}
